/**
 * @generated SignedSource<<512305bb90c4d810cca45ef73ff374db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FirstBookingStatus = "confirmed" | "created" | "declined" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FirstBookingActions_contract$data = {
  readonly contractId: string;
  readonly hasFulfilledBooking: boolean;
  readonly firstBookingStatus: FirstBookingStatus;
  readonly firstBookingConfirmationStatus: {
    readonly description: string;
    readonly reason: string;
  } | null;
  readonly firstBooking: {
    readonly bookingId: string;
    readonly startDate: string;
    readonly endDate: string;
    readonly isFirstBooking: boolean;
  } | null;
  readonly serviceRequest: {
    readonly schedule: {
      readonly durationInMinutes: number;
      readonly isFlexible: boolean;
      readonly isAllDay: boolean;
    };
  };
  readonly " $fragmentType": "FirstBookingActions_contract";
};
export type FirstBookingActions_contract$key = {
  readonly " $data"?: FirstBookingActions_contract$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstBookingActions_contract">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FirstBookingActions_contract",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contractId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasFulfilledBooking",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstBookingStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "firstBookingConfirmationStatus",
      "kind": "LinkedField",
      "name": "firstBookingConfirmationStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Booking",
      "kind": "LinkedField",
      "name": "firstBooking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookingId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFirstBooking",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceRequest",
      "kind": "LinkedField",
      "name": "serviceRequest",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Schedule",
          "kind": "LinkedField",
          "name": "schedule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationInMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isFlexible",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contract",
  "abstractKey": null
};

(node as any).hash = "06357b4d7401ac25e6b3754c8bab455d";

export default node;
